module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/260.289f3e26.png";